var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CContainer',[_c('CRow',[_c('h6',[_vm._v(" En este módulo podrá consultar la ejecución del presupuesto asignado al centro de costo. ")])]),_c('CRow',[_c('CCol',[_c('CCard',[_c('CCardBody',[_c('CChartPie',{staticStyle:{"height":"300px"},attrs:{"datasets":[
                        {
                            data: [
                                80,
                                5,
                                15
                            ],
                            backgroundColor: [
                                '#3f51b5',
                                '#4a6ebb',
                                '#804acd'
                            ],
                            label: 'Sales',
                        }
                        ],"labels":['Ejecutado', 'Disponible', 'Reservado'],"options":{ maintainAspectRatio: false, responsive: true }}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }